import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-file-picker',
  templateUrl: './modal-file-picker.component.html',
  styleUrl: './modal-file-picker.component.scss'
})
export class ModalFilePickerComponent {

  fileChangedEvent: any = '';
  file?: any;
  loading = false;
  isFromTravel = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
  ) {
    if(config.data.fromTravel === true){
      this.isFromTravel = true;
    }
  }

  fileChangeEvent(event: any): void {
    this.loading = true;
    this.fileChangedEvent = event;
    this.file = event.target.files[0];
    if(this.file){
      this.loading = false;
    }
  }

  close() {
    this.ref.close();
  }

  save(){
    this.ref.close({file: this.file})
  }

}
